import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { withBrand } from '../../../../providers/BrandProvider';

import { ModalLink, FlightTypeSelector } from './components';
import { BoxHeading, BoxParagraph } from '../shared';
import { PriceInfo } from './styles';

const Wrapper = styled.div`
  direction: ltr;
  border-top: ${(props) => `1px solid ${props.borderColor}`};
`;

export function CarbonOffsetBox(props) {
  const {
    onCarbonOffsetChange,
    carbonOffset,
    brand: { secondaryColor },
  } = props;
  const { t } = useTranslation();

  return (
    <Wrapper borderColor={secondaryColor}>
      <BoxHeading color={secondaryColor}>
        {t('site.purchase.select-package.carbon.title')}
      </BoxHeading>

      <BoxParagraph color={secondaryColor}>
        {t('site.purchase.select-package.carbon.subTitle')}
      </BoxParagraph>

      <ModalLink color={secondaryColor} />

      <BoxParagraph color={secondaryColor} textTransform="capitalize">
        {t('site.purchase.select-package.carbon.select-flight-type')}
      </BoxParagraph>

      <FlightTypeSelector
        onCarbonOffsetChange={onCarbonOffsetChange}
        carbonOffset={carbonOffset}
        activeColorStyle={secondaryColor}
      />

      <PriceInfo>
        {t('site.purchase.select-package.carbon.price-info')}
      </PriceInfo>
    </Wrapper>
  );
}

CarbonOffsetBox.propTypes = {
  onCarbonOffsetChange: PropTypes.func,
  carbonOffset: PropTypes.string,
  brand: PropTypes.shape({
    secondaryColor: PropTypes.string,
  }),
};

export default withBrand(CarbonOffsetBox);
